import { render, staticRenderFns } from "./courseManagement.vue?vue&type=template&id=6aac2a78&"
import script from "./courseManagement.vue?vue&type=script&lang=js&"
export * from "./courseManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports